$(document).ready(function() {
  setUpGetMinTier();

  $('#max-achievement-id').change(function() {
    setUpGetMinTier();
  })

  $('#min-achievement-id').change(function() {
    updateAchievementMaxOptions($(this).val());
  })

  $('.btn-save-tqg-qualification').click(function() {
    if (!$('#max-achievement-id')[0].disabled) {
      var range_tiers = $('#range_tiers').data('range-tier');

      if (!!$('#max-achievement-id').val()) {
        if (confirm(range_tiers) == false) {
          return false;
        }
      }
    }
  })

  function setUpGetMinTier() {
    var max_achievement_id    = $('#max-achievement-id').val();
    var tqg_incentive_trip_id = $('#tqg-incentive-trip-id').val();
    var min_achievement       = $('#min-achievement-id option:selected').text();

    if (!!max_achievement_id) {
      getMinTier(max_achievement_id, tqg_incentive_trip_id, min_achievement);
    }
  }

  function getMinTier(max_achievement_id, tqg_incentive_trip_id, min_achievement) {
    $.ajax({
      type: "GET",
      dataType:"json",
      data: { 'max_achievement_id' : max_achievement_id },
      url: `/admin/tqg_incentive_trips/${tqg_incentive_trip_id}/tqg_incentive_qualifications/get_prev_max_achievement`,
      success: function(response){
        var alert_text = I18n.t('global.notices.user_with_level') + ` ${min_achievement} - ${response.max_tier} ` + I18n.t('global.notices.have_the_opportunity_to_qualify_this_incentive_trip');

        $('#range_tiers').data('range-tier', `Are you sure ? \n ${alert_text}`);
        $('#achievement-tier-detail').html(`#${alert_text}`);
      }
    });
  }

  function updateAchievementMaxOptions(min_achievement_id) {
    var tqg_incentive_trip_id = $('#tqg-incentive-trip-id').val();

    $.ajax({
      type: "GET",
      dataType:"json",
      data: { 'min_achievement_id' : min_achievement_id },
      url: `/admin/tqg_incentive_trips/${tqg_incentive_trip_id}/tqg_incentive_qualifications/get_max_achievement_options`,
      success: function(response){
        $('#max-achievement-id').val('');
        $('#max-achievement-id').empty();
        $('#achievement-tier-detail').empty();

        max_achievements = response.max_achievements;
        $('#max-achievement-id').append("<option value>"+ I18n.t('actions.select', {item: I18n.t('global.maximum_achievement')}) +"</option>");

        $.each(max_achievements, function(_key, data) {
          let option = $("<option></option>");
              option.attr("value", data.id);
              option.text(data.level_name);

          $('#max-achievement-id').append(option);
        })
      }
    });
  }

  $('.btn-save-tqg-incentive-trip').click(function() {
    if ($('#tqg-incentive-banner-preview').length >= 1) {
      return true;
    }

    if (!$('#tqg_incentive_trip_banner').val()) {
      alert(I18n.t('global.alerts.banner_cant_be_blank'))
      return false;
    }
  })

  // Filter chart
  $('#filter-by-chart_period').change(function(){
    $('#submit-filter-by-chart-period').click();

    if ($('#input-chart-period').val() == "all") {
      setTimeout(() => {
        $(".label-current-date").hide();
        return false;
      }, 100);
    }
  })

  // $('select#chart_period').on('change', function() {
  //   var selectedDate = $("select#chart_period").children("option:selected").val();

  //   if (selectedDate == "all") {
  //     $(".label-current-date").hide();
  //     // return false;
  //   }
  // });

  // Filter user pv activity
  $(".custom-select-item").click(function (e) {
    e.stopPropagation();
    $(".user-pv-select-options").toggle();
  });

  $(".user-pv-select-option").click(function () {
    const selectedText = $(this).text();
    $(".select-label").text(selectedText);
    $(".user-pv-select-options").hide();
  });

  $(document).click(function () {
    $(".user-pv-select-options").hide();
  });

  $(".hoverable").hover(
    function () {
      $(this).find(".monthly-options").show();
    },
    function () {
      $(this).find(".monthly-options").hide();
    }
  );

  // $('.user-pv-select-option').click(function(){
  //   $('#input-filter-user-pv-activity').val($(this).attr('value'));
  //   $('#submit-filter-by-user-pv-activity').click();
  // })

  $('#filter-activity-by-month').change(function(){
    $('#submit-filter-by-user-pv-activity').click();
  })
});
